import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=7fc98b41&scoped=true"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=7fc98b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../TweeAT.HvA.CourseCatalog/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc98b41",
  null
  
)

export default component.exports